import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import my from './my.json';

export type Lang = 'my' | 'en';
const STORAGE_KEY = 'klx.lang';

export function storedLang(): Lang {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'my' || v === 'en') return v;
  } catch { /* storage unavailable */ }
  return 'my';
}

export function setLang(lang: Lang) {
  try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* ignore */ }
  void i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, my: { translation: my } },
  lng: storedLang(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
